import * as e from "react";
import i from "../lib/IconBase.es.js";
import m from "../defs/SpeakerSimpleHigh.es.js";
const o = e.forwardRef((r, a) => /* @__PURE__ */ e.createElement(i, { ref: a, ...r, weights: m }));
o.displayName = "SpeakerSimpleHighIcon";
const c = o;
export {
  c as SpeakerSimpleHigh,
  o as SpeakerSimpleHighIcon
};
